module.exports = __webpack_public_path__ + "static/media/NewIBES-Logo-Dark.8d8ad287.png";